import React from "react";

export default function SectionCard({ title, subtitle, children, rightSlot = null }) {
  return (
    <div className="rounded-[14px] border border-black/10 bg-white p-6 dark:border-white/[0.07] dark:bg-[#141824]">
      <div className="flex items-start justify-between gap-4 mb-5">
        <div>
          <h3 className="text-[9px] font-bold uppercase tracking-[1px] text-[#64748b] dark:text-[#6b7a9a]">{title}</h3>
          {subtitle ? (
            <p className="text-[12px] text-[#64748b] dark:text-[#6b7a9a] mt-1">{subtitle}</p>
          ) : null}
        </div>
        {rightSlot}
      </div>
      {children}
    </div>
  );
}
